$(function () {
    if(window.flindersHeaderCodeHasRun){
        return;
    }
    window.flindersHeaderCodeHasRun = true;
    var widthMobile = 990;
    var headerQuicklink = $('.header_quicklink');

    // yellow band -> mobile version subheader -> burger
    if ($('.subpage_global_header .top_main_navigation > li > a').length) {
        $('#navbar-main-top-collapse .top_main_navigation').append('<li id="global-mobile-navigation" class="nav-item dropdown"><a href="/content/flinders.html" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" class="nav_top_link 2">Global navigation</a><div class="dropdown-menu"><div id="dropmenu_section_global" class="dropmenu_section"></div></div></li>');
    }

    $('.subpage_global_header .top_main_navigation > li > a').each(function () {
    	var current_header_item = $(this);
    	var current_header_item_dom_int_class = '';
    	var current_header_item_dom_int_style = '';
    	var current_dom_int_state = current_state; //This comes from domestic-international-toggle.js
    	if(current_header_item.hasClass('domestic_content') && !current_header_item.hasClass('international_content')) {
    		current_header_item_dom_int_class = 'domestic_content';
    		if(current_dom_int_state === 'int') {
    			current_header_item_dom_int_style = "display:none;";
    		}
    	}
    	if(current_header_item.hasClass('international_content') && !current_header_item.hasClass('domestic_content')) {
    		current_header_item_dom_int_class = 'international_content';
    		if(current_dom_int_state === 'dom') {
    			current_header_item_dom_int_style = "display:none;";
    		}
    	}
        $('#global-mobile-navigation .dropmenu_section').append('<p class="link_overview '+ current_header_item_dom_int_class +'" style="'+current_header_item_dom_int_style+'"><a href="' + current_header_item.prop("href") + '">' + current_header_item.text() + '</a></p>');

        var subPagesDomIntlMenu = $('.smDomIntlSubPageMenu');
        subPagesDomIntlMenu.show();
        $('#global-mobile-navigation').after(subPagesDomIntlMenu);
    });


    /*clone logo in subheader*/
    var headerWrapper = $('.js-header-wrap');
    headerWrapper
        .append($('.js-header-search-side')
            .clone());

    headerQuicklink.click(function () {
        var mainNavbar = $('#navbar-main-top-collapse');
        if (mainNavbar.hasClass('in') == true) {
            mainNavbar.collapse('hide');
        }

        const parent = jQuery(headerQuicklink).closest('.head_inner_horisontal')

        const target = parent.find('.mini_mega_menu');
        


        //NOTE(Christof): for some reason this is running before the 'open' class is applied (by bootstrap maybe?) so we have to invert that check here.
        if (parent.length && !target.hasClass('open') && window.innerWidth < widthMobile) {
            const component = document.querySelector(".cmp-flindersonline-notification");
            const reciteMeHeader = document.getElementById("recite-header");
            const reciteMeHeight = reciteMeHeader ? reciteMeHeader.offsetHeight : 0;
            const NewHeight = (component ? component.offsetHeight :0) + reciteMeHeight;
            parent.find('.dropdown-menu').css('margin-top', NewHeight+'px');

        } else {
            parent.find('.dropdown-menu').css('margin-top', '');
        }
    });

    $('.nav_top_link').each(function () {
        if ($(this).siblings('div').find('.dropmenu_section:eq(0)').attr('id') == 'dropmenu_section_global') {
            return true;
        }
        $(this).siblings('div').find('.dropmenu_section:eq(0)').prepend('<p class="link_overview"><a href="' + $(this).attr('href') + '">Overview</a></p>');
    });

    // dropdown -> disabled -> for mobile version
    $('.top_main_navigation .dropdown').on('click.bs.dropdown', function () {
        if ($(window).width() > widthMobile) {
            if ($(this).children('a:visible').attr('target')) {
                window.open($(this).find('a').attr('href'), $(this).find('a').attr('target'));
            } else {
                window.location = $(this).find('a').attr('href');
            }
        }
    });
    $('.top_main_navigation a[attr="data-toggle"]').on('click.bs.dropdown', function () {
        if ($(window).width() > widthMobile) {
            if ($(this).children('a:visible').attr('target')) {
                window.open($(this).children('a').attr('href'), $(this).children('a').attr('target'));
            } else {
                window.location = $(this).find('a').attr('href');
            }
        }
    });
    $('.top_main_navigation .dropdown > div a:not([data-toggle="dropdown"])').on('click', function () {
        if ($(this).attr('target')) {
            window.open($(this).attr('href'), $(this).attr('target'));
        } else {
            window.location = $(this).attr('href');
        }
        return false;
    });

    var logoLine = $('.logo_line');
    var headerSite = $('.home_header_line');

    mousedown = false;
    $('a').on('mousedown', function () {
        mousedown = true;
    });
    $('a').on('focus', function () {
        if ($(window).width() > widthMobile) {
            if ($(this).parents('.top_main_navigation, .header_quicklink_section')[0]) {
                if (!$(this).parents('li').hasClass('open_row')) {
                    $('.top_main_navigation > li, .header_quicklink_section > li').removeClass('open_row');
                    $(this).parents('li').addClass('open_row');
                    logoLine.addClass('header_active');
                    headerSite.addClass('header_active');
                }
                clearTimeout(window['top_main_navigation_blur']);
                var search_icon = $('.header_search_top');
                if (search_icon.hasClass('active')) {
                    search_icon.removeClass('active');
                    $('.logo_line').removeClass('header_active').removeClass('search_transorm_dark_bg');
                    $('.home_header_line').removeClass('header_active');
                    $('.header_global_search_form').stop().fadeOut();
                }
            } else {
                $('.top_main_navigation > li, .header_quicklink_section > li').removeClass('open_row');
                if (!mousedown) {
                    logoLine.removeClass('header_active');
                    headerSite.removeClass('header_active');
                    if ($(this).parent().hasClass('header_search_top')) {
                        $(this).click();
                    } else {
                        var search_icon = $('.header_search_top');
                        if (search_icon.hasClass('active')) {
                            search_icon.removeClass('active');
                            $('.logo_line').removeClass('header_active').removeClass('search_transorm_dark_bg');
                            $('.home_header_line').removeClass('header_active');
                            $('.header_global_search_form').stop().fadeOut();
                        }
                    }
                }
            }
            mousedown = false;
        }
    });
    $('.top_main_navigation a').on('blur', function () {
        if ($(window).width() > widthMobile) {
            window['top_main_navigation_blur'] = setTimeout(function () {
                $('.top_main_navigation > li, .header_quicklink_section > li').removeClass('open_row');
                logoLine.removeClass('header_active');
                headerSite.removeClass('header_active');
            }, 150);
        }
    });
    // Multi-Level Dropdowns -> for mobile version
    $('.head_list_heading a').on('click', function (e) {
        var element = $(this);
        var parentElement = element.parent();

        if ($(window).width() > widthMobile) {
            window.location = element.attr('href');
        } else {
            if (parentElement.next('ul:hidden')[0]) {
                parentElement.addClass('open');
            } else {
                parentElement.removeClass('open');
            }
            parentElement
                .next('ul')
                .toggle();
        }
        e.stopPropagation();
        e.preventDefault();
    });
    $('.top_main_navigation, .header_quicklink_section').menuAim({
        tolerance: 20,
        submenuDirection: 'below',
        activate: function (row) {
            var $row = $(row);
            var dataRole = $row.parent().attr('data-role');
            $row.addClass('open_row');
            logoLine.addClass('header_active');
            headerSite.addClass('header_active');
            $('.js-menu-aim').each(function () {
                clearTimeout(window[dataRole + '_yellow']);
            });
            $('.header_search_top').removeClass('active');
            $('.header_global_search_form').hide();
        },
        deactivate: function (row) {
            $(row).removeClass('open_row');
            if ($('.header_search_top').hasClass('active')) {
                logoLine.removeClass('header_active');
                headerSite.removeClass('header_active');
            }
        },
        enter: function (row) {
            var $row = $(row);
            var dataRole = $row.parent().attr('data-role');

            if (!$row.siblings('.open_row')[0]) {
                $row.addClass('open_row');
            }
            logoLine.addClass('header_active');
            headerSite.addClass('header_active');

            clearTimeout(window[dataRole + '_close']);
            $('.js-menu-aim').each(function () {
                clearTimeout(window[$(this).attr('data-role') + '_yellow']);
            });
            $('.header_search_top').removeClass('active');
            $('.header_global_search_form').hide();
        },
        exitMenu: function (menu) {
            var $menu = $(menu);
            var dataRole = $menu.attr('data-role');
            window[dataRole + '_close'] = setTimeout(function () {
                if($("[id^=deleteCourseBookmarkConfirmationDialog]").hasClass('in')){
                    $('#sc').addClass('open_row');
                } else {
                    $(menu)
                        .children()
                        .removeClass('open_row');
                }
            }, 150);
            window[dataRole + '_yellow'] = setTimeout(function () {
                if (!$('.header_search_top').hasClass('active')) {
                    logoLine.removeClass('header_active');
                    headerSite.removeClass('header_active');
                }
            }, 150);
        }
    });
    var burger = $('.header_burger');
    var scrollPosition = 0;

    //JD: Maybe make sure the thing we want to observe actually exists before observing...
    if(burger.length > 0) {
        var observer = new MutationObserver(function (mutations) {
            var scrollSetted = false;
            mutations.forEach(function (mutation) {
                if (mutation.type == "attributes") {
                    if (mutation.attributeName == "aria-expanded") {
                        if ($('.header_burger[aria-expanded="true"]').length) {
                            if (!scrollSetted) {
                                scrollPosition = $(document).scrollTop();
                                scrollSetted = true;
                            }
                            $('body').addClass("hiddenOverflow");
                        } else {

                            $('body').removeClass("hiddenOverflow");
                            $(document).scrollTop(scrollPosition);
                        }
                    }
                }
            });
        });

        observer.observe(burger.get(0), {
            childList: true,
            attributes: true,
            characterData: true,
            attributeFilter: ['aria-expanded']
        });
    }
    fixupHeaderPadding();
});

window.fixupMobileMenu = function(){
  const top_main_navigation_wrap = document.querySelector("#navbar-main-top-collapse .top_main_navigation_wrap");
  if(top_main_navigation_wrap) {
    var widthMobile = 990;
    var isMobile = $(window).width() <= widthMobile;

    if(isMobile){
      const reciteMeHeader = document.getElementById("recite-header");
      const reciteTooltip = document.getElementById("recite-tooltip");
      const reciteTooltipHeight = reciteTooltip ? reciteTooltip.offsetHeight : 0;
      const reciteHeaderHeight = reciteMeHeader ? reciteMeHeader.offsetHeight : 0;

      //NOTE(Christof): really should handle multiple notifications here properly, but nothing else does, so this is fine
      const notificationElement = document.querySelector(".cmp-flindersonline-notification");
      const notificationHeight = notificationElement ? notificationElement.offsetHeight : 0;
      top_main_navigation_wrap.style.height = "calc( 100% - ( "+reciteHeaderHeight +"px * 1 / var(--recite-me-zoom) ) - "+(reciteTooltipHeight + notificationHeight)+"px )";
      top_main_navigation_wrap.style.top = "calc( " + reciteHeaderHeight + "px * 1 / var(--recite-me-zoom) + " + notificationHeight+"px )";
    }

  }
}


var fixupHeaderPaddingRunning = false;
window.fixupHeaderPadding = function(){
    if(fixupHeaderPaddingRunning){
        return;
    }
    const navigationGlobal = document.querySelector(".navigation-global");
    
    if(navigationGlobal){
        navigationGlobal.style.paddingTop = "";
        //NOTE(Christof): really should handle multiple notifications here properly, but nothing else does, so this is fine
        const notificationElement = document.querySelector(".cmp-flindersonline-notification");
        const notificationHeight = notificationElement  ? notificationElement.offsetHeight : 0;
        var isStaffPortalHeader = false;
        if($(".sub_site_header").length) {
            isStaffPortalHeader = true;
        }
        var widthMobile = 990;
        var isMobile = $(window).width() <= widthMobile;

        var isHomePageHeader = document.body.classList.contains("main_page_body") ;
        
        fixupHeaderPaddingRunning = true;
        requestAnimationFrame(function(){
            fixupHeaderPaddingRunning = false;
            const isAuthor = document.getElementsByClassName("aem_author_mode").length > 0;
            if(isMobile || (!isAuthor && isStaffPortalHeader)){
                var Height = navigationGlobal.offsetHeight + notificationHeight + "px";
                navigationGlobal.style.paddingTop = Height;
            }
        });
        
    }

}
